import { CurrencyInputBaseProps } from '../currency-field/currency-input-base/currency-input-base.component';
import { IncField } from '../fields.types';
import CurrencyField from '../currency-field/currency-field.component';

export type CountingNumberFieldProps = IncField<CurrencyInputBaseProps> & {
  onInputValueChange?: (e: any) => void;
};

const CountingNumberField = ({
  inputProps = {},
  ...rest
}: CountingNumberFieldProps) => {
  return (
    <CurrencyField
      data-testid="CountingNumberField"
      inputProps={{
        step: 1,
        allowDecimals: false,
        disableGroupSeparators: true,
        ...inputProps,
      }}
      currencySymbol={null}
      {...rest}
    />
  );
};

export default CountingNumberField;
